'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactTinymce = require('react-tinymce');

var _reactTinymce2 = _interopRequireDefault(_reactTinymce);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BinaryRichTextEditor = function (_Component) {
  _inherits(BinaryRichTextEditor, _Component);

  function BinaryRichTextEditor() {
    _classCallCheck(this, BinaryRichTextEditor);

    return _possibleConstructorReturn(this, (BinaryRichTextEditor.__proto__ || Object.getPrototypeOf(BinaryRichTextEditor)).apply(this, arguments));
  }

  _createClass(BinaryRichTextEditor, [{
    key: 'handleChange',
    value: function handleChange(editor) {
      var onChange = this.props.onChange;

      onChange(editor.target.getContent());
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          content = _props.content;

      return _react2.default.createElement(_reactTinymce2.default, {
        content: content,
        className: className,
        config: {
          elementpath: false,
          body_class: 'no-margin',
          height: 600,
          menubar: false,
          resize: false,
          visual: false,
          plugins: ['noneditable'],
          toolbar: 'undo redo | bold italic | bullist numlist | alignleft aligncenter alignright'
        },
        onChange: this.handleChange.bind(this)
      });
    }
  }]);

  return BinaryRichTextEditor;
}(_react.Component);

BinaryRichTextEditor.propTypes = {
  className: _propTypes2.default.string,
  content: _propTypes2.default.string,
  onChange: _propTypes2.default.func
};
exports.default = BinaryRichTextEditor;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@pgforsta/mozart_ui/lib/components/Binary/BinaryRichTextEditor/BinaryRichTextEditor.js
// module id = 2239
// module chunks = 1